import React from 'react';
import PropTypes from 'prop-types';

import { Modal, Button, Message } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import Style from './confirmModal.module.css';

export default function ConfirmModal({ actionInstance = null, mode = 'orders', onClose = () => {}, onSubmit = () => {}, bodyContent = '' }) {
    const { t } = useTranslation();
    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const handleSubmit = React.useCallback(() => {
        onSubmit(setIsSubmitting);
    }, [onSubmit]);

    const _onClose = React.useCallback(() => {
        onClose();
        setIsSubmitting(false);
    }, [onClose]);

    return (
        <Modal
            size="medium"
            open={Boolean(actionInstance)}
            onClose={_onClose}
            title={actionInstance ? t('ticket.manager.' + mode + '.action.' + actionInstance.constructor.NAME + '.title', { count: actionInstance.filtered_items.length }) : ''}
            submitButton={
                <Button primary onClick={handleSubmit} disabled={isSubmitting} isLoading={isSubmitting} label={`${actionInstance ? t('ticket.common.action.confirm') : ''}`} />
            }
            cancelButton={<Button onClick={_onClose} label={t(`ticket.common.action.cancel`)} />}
        >
            {bodyContent}
            {actionInstance.warning_confirm && (
                <Message className={Style['warning_message']} type="warning" title={t('ticket.common.warning')}>
                    {t('ticket.manager.' + mode + '.action.' + actionInstance.constructor.NAME + '.warning')}
                </Message>
            )}
        </Modal>
    );
}

ConfirmModal.propTypes = {
    actionInstance: PropTypes.object,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    bodyContent: PropTypes.node
};
